import React from 'react'
import styled from '@emotion/styled'
import { object, string } from 'prop-types'
import { Link } from '@jelly/ui'

const ResourceWrapper = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	margin: 40px auto;
`

const DownloadButton = styled(Link)`
	${({ theme }) => theme.buttons.default};
	margin: 20px auto;
`

export function ContentResource({ resource = {}, type = 'article' }) {
	return (
		resource.path && (
			<ResourceWrapper>
				<div className={`download-lead-text`}>
					{resource.description
						? resource.description
						: `Want to learn more? View our ${type.charAt(0).toUpperCase() + type.slice(1)}`}
				</div>
				<DownloadButton href={resource.path} target={`download_${type}`}>
					{resource.cta ? resource.cta : `Download ${type}`}
				</DownloadButton>
			</ResourceWrapper>
		)
	)
}

ContentResource.propTypes = {
	resource: object.isRequired,
	type: string.isRequired,
}
